import React from "react";
import { FormattedMessage } from "react-intl";

import styles from "./StaticTextPage.module.css";
import { useT } from "../helpers/useT";

type StaticTextPageProps = {
  translationPrefixKey: string;
  locale: "en" | "de";
};

StaticTextPage.getInitialProps = async ({
  query: { locale, translationPrefixKey },
}: {
  query: StaticTextPageProps;
}) => {
  return {
    locale,
    disableLinkToHome: true,
    translationPrefixKey,
  };
};

export function StaticTextPage(props: StaticTextPageProps) {
  const t = useT();
  if (props.translationPrefixKey === "chauffeur-privacy-policy") {
    window.location.href = t("chauffeur-privacy-policy.link");
    return <>Redirecting...</>;
  }

  return (
    <article className={styles.root}>
      <header>
        <FormattedMessage
          tagName="h4"
          id={`${props.translationPrefixKey}.title`}
        />
        <FormattedMessage
          tagName="p"
          id={`${props.translationPrefixKey}.subtitle`}
        />
      </header>
      <FormattedMessage id={`${props.translationPrefixKey}.summary`}>
        {(txt) => (
          <p
            className={styles.summary}
            dangerouslySetInnerHTML={{ __html: txt as any }}
          />
        )}
      </FormattedMessage>

      <FormattedMessage id={`${props.translationPrefixKey}.body`}>
        {(txt) => <section dangerouslySetInnerHTML={{ __html: txt as any }} />}
      </FormattedMessage>
    </article>
  );
}
